import { PaymentMethod } from '../../types/payment/payment'

/** Smallest card charge (RON), mirroring the server's app-config.minCardCharge. */
export const MIN_CARD_CHARGE = 10

const round = (value: number) => Math.round(value * 100) / 100

/**
 * Refund points that pay for {@code amount}, mirroring the server (RefundPointService.applicable): as many as available,
 * except that a card payment is never left with less than {@link MIN_CARD_CHARGE} (fewer points are used instead; an
 * amount below the minimum is then paid by card alone). The server decides on checkout; this only previews it.
 */
export const applicablePoints = (amount: number, available: number, paymentMethod: PaymentMethod = PaymentMethod.CARD) => {
  if (amount <= 0 || available <= 0) {
    return 0
  }
  let points = Math.min(available, amount)
  const remainder = round(amount - points)
  if (paymentMethod === PaymentMethod.CARD && remainder > 0 && remainder < MIN_CARD_CHARGE) {
    points = amount >= MIN_CARD_CHARGE ? amount - MIN_CARD_CHARGE : 0
  }
  return round(points)
}
